import { render, staticRenderFns } from "./EditRoomPopup.vue?vue&type=template&id=5cd87f4f&scoped=true"
import script from "./EditRoomPopup.vue?vue&type=script&lang=ts"
export * from "./EditRoomPopup.vue?vue&type=script&lang=ts"
import style0 from "./EditRoomPopup.vue?vue&type=style&index=0&id=5cd87f4f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd87f4f",
  null
  
)

export default component.exports